// @flow
import React from 'react'
import Path from 'routes/path'
import LoginPage from 'containers/pages/LoginPage'
import SignUpPage from 'containers/pages/SignUpPage'
import SignOutPage from 'containers/pages/SignOutPage'
import SignUpSentPage from 'containers/pages/SignUpSentPage'
import SignUpReconfirmationPage from 'containers/pages/SignUpReconfirmationPage'
import PasswordResetNewPage from 'containers/pages/PasswordResetNewPage'
import PasswordResetEditPage from 'containers/pages/PasswordResetEditPage'
import NotificationSettingPage from 'containers/pages/NotificationSettingPage'
import HostEntryPage from 'containers/pages/HostEntryPage'
import HostSignUpPage from 'containers/pages/HostSignUpPage'

export default [
  {
    path: Path.login(),
    exact: true,
    component: LoginPage,
  },
  {
    path: Path.signUp(),
    exact: true,
    component: SignUpPage,
  },
  {
    path: Path.signOut(),
    exact: true,
    component: SignOutPage,
  },
  {
    path: Path.signUpSent(),
    exact: true,
    component: SignUpSentPage,
  },
  {
    path: Path.signUpReconfirmation(),
    exact: true,
    component: SignUpReconfirmationPage,
  },
  {
    path: Path.notificationSetting(),
    exact: true,
    component: NotificationSettingPage,
  },
  {
    path: Path.passwordReset(),
    exact: true,
    component: PasswordResetNewPage,
  },
  {
    path: Path.passwordResetEdit(),
    exact: true,
    component: PasswordResetEditPage,
  },
  {
    path: Path.hostEntry(),
    exact: true,
    component: HostEntryPage,
  },
  {
    path: Path.hostSignUp(),
    exact: true,
    component: HostSignUpPage,
  },
]
